import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { NavigationText } from '../../../../../../core/constants/navigation-text';

@Injectable({
    providedIn: 'root',
})
export class OrderDetailsActionService {
    private saveChangesSubject = new Subject<void>();
    saveChanges$ = this.saveChangesSubject.asObservable();

    private printSubject = new Subject<void>();
    print$ = this.printSubject.asObservable();

    private printButtonLabelSubject = new BehaviorSubject<string>(
        NavigationText.PRINT,
    );
    printButtonLabel$ = this.printButtonLabelSubject.asObservable();

    /**
     * Emits an event to signal that the "Save Changes" action has been triggered.
     */
    triggerSaveChangesClick(): void {
        this.saveChangesSubject.next();
    }

    /**
     * Emits an event to signal that the "Print" action has been triggered.
     */
    triggerPrintClick(): void {
        this.printSubject.next();
    }

    /**
     * Sets the label for the print button based on the balance.
     *
     * @param balance The balance of the order.
     */
    setPrintButtonLabel(balance: number): void {
        this.printButtonLabelSubject.next(
            balance > 0
                ? NavigationText.PRINT_INVOICE
                : NavigationText.PRINT_RECEIPT,
        );
    }
}
